import React from 'react';

const icon2 = () => {
    return (
        <>
           <svg
                    width="31"
                    height="31"
                    viewBox="0 0 31 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.84961 26.5703H21.8496C23.1757 26.5703 24.4475 26.0435 25.3851 25.1058C26.3228 24.1682 26.8496 22.8964 26.8496 21.5703V6.57031C26.8496 5.90727 26.5862 5.27139 26.1174 4.80255C25.6485 4.3337 25.0127 4.07031 24.3496 4.07031H11.8496C11.1866 4.07031 10.5507 4.3337 10.0818 4.80255C9.613 5.27139 9.34961 5.90727 9.34961 6.57031V22.8203C9.34961 24.8916 8.92086 26.5703 6.84961 26.5703Z"
                      stroke="white"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4.34961 12.8203C4.34961 12.1573 4.613 11.5214 5.08184 11.0525C5.55068 10.5837 6.18657 10.3203 6.84961 10.3203H9.34961V23.4453C9.34961 25.1703 8.57461 26.5703 6.84961 26.5703C5.12461 26.5703 4.34961 25.1703 4.34961 23.4453V12.8203Z"
                      stroke="white"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M15.5996 11.5703C16.29 11.5703 16.8496 11.0107 16.8496 10.3203C16.8496 9.62996 16.29 9.07031 15.5996 9.07031C14.9093 9.07031 14.3496 9.62996 14.3496 10.3203C14.3496 11.0107 14.9093 11.5703 15.5996 11.5703Z"
                      stroke="white"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.3496 17.8203H21.8496"
                      stroke="white"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.3496 21.5703H18.0996"
                      stroke="white"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg> 
        </>
    );
};

export default icon2;